import { Component } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
import { trigger, state, style, animate, transition, query, animateChild, keyframes } from '@angular/animations';

/**
 * Login component
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('tab', [
      transition(':enter', [
        style({ opacity: '0', height: '0' }),
        animate(
          '.3s ease-in-out',
          keyframes([style({ opacity: '0', height: '0', offset: 0 }), style({ opacity: '1', height: '*', offset: 1 })])
        ),
      ]),
      transition(':leave', [
        style({ opacity: '1', height: '*' }),
        animate(
          '.3s ease-in-out',
          keyframes([style({ opacity: '1', height: '*', offset: 0 }), style({ opacity: '0', height: '0', offset: 1 })])
        ),
      ]),
    ]),
  ],
})
export class LoginComponent {
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, GCValidators.validateEmail]),
    password: new FormControl('', [Validators.required]),
  });

  resetForm = new FormGroup({
    email: new FormControl('', [Validators.required, GCValidators.validateEmail]),
  });

  resetFormIsOpen: boolean = false;
  resetRequestSuccessful: boolean = false;

  loginError: string = '';
  resetError: string = '';

  constructor(private auth: AuthService, private router: Router, private user: UserService) {
    if (router.url === '/login/reset') {
      this.resetFormIsOpen = true;
    }
  }

  login() {
    if (this.loginForm.valid) {
      this.loginError = '';
      this.loginForm.disable();
      this.auth
        .login(this.loginForm.value.email, this.loginForm.value.password)
        .then((result) => {
          this.router.navigate(['/dashboard']);
        })
        .catch((error) => {
          const message = error.body.error;

          if (message === 'Account is not active.') {
            this.loginError = 'finishRegistration';
          } else if (message === 'No valid licence could be found for this account.') {
            this.loginError = 'noValidLicence';
          } else {
            this.loginError = 'general';
          }

          this.loginForm.enable();
        });
    }
  }

  openResetForm(e) {
    e.preventDefault();
    this.resetFormIsOpen = true;
  }

  closeResetForm(e) {
    e.preventDefault();
    this.resetFormIsOpen = false;
  }

  resetPW(event) {
    event.preventDefault();
    if (this.resetForm.valid) {
      this.resetForm.disable();
      this.user
        .requestPasswordReset(this.resetForm.value.email)
        .then((result) => {
          this.resetRequestSuccessful = true;
        })
        .catch((error) => {
          if (error.body.error === 'No account found.') {
            this.resetError = 'noAccount';
          }

          this.resetForm.enable();
        });
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/login/login.component.ts